import * as React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * @typedef {Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>} CheckboxProps
 */

/**
 * Renders a styled checkbox component.
 * It's a controlled component that forwards all native input props.
 * @param {CheckboxProps} props
 * @param {React.Ref<HTMLInputElement>} ref
 */
function CheckboxComponent({ className, ...props }, ref) {
  return (
    <input
      type="checkbox"
      className={twMerge(
        clsx(
          'h-4 w-4 rounded text-primary focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50',
          className,
        ),
      )}
      ref={ref}
      {...props}
    />
  );
}

const Checkbox = React.forwardRef(CheckboxComponent);

Checkbox.displayName = 'Checkbox';

export { Checkbox };
